module.exports = __webpack_public_path__ + "img/Image1.cb429431.png";